import produce from 'immer';

import type { ArticlesList, Category } from '@swf/help';

import { defaultState } from './defaultState';

type State = typeof defaultState;

interface DataLoadSuccessPayload {
  categoriesList?: Category[];
  articlesList: ArticlesList;
}

export const reducers = {
  dataRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  dataLoadSuccess: (
    state: State,
    { categoriesList, articlesList }: DataLoadSuccessPayload
  ): State => ({
    ...state,
    ...(categoriesList && { categoriesList }),
    categoryArticles: articlesList.articles,
    categoryArticlesMeta: articlesList?.meta,
    preloaded: true,
    isLoading: false,
    error: false
  }),
  dataLoadFailed: (state: State): State => ({
    ...state,
    error: true,
    isLoading: false,
    preloaded: true
  }),
  clear: (): State => produce(defaultState, (draft) => draft)
};
